import {searchClient} from '@algolia/client-search';
const appId = window.envvars?.algolia_application_id;
const apiKey = window.envvars?.algolia_api_key;
const indexName = window.envvars?.algolia_index_name;
let algoliaSearchClient = null;
let algoliaIndexName = null;

if (appId && apiKey && indexName) {
    algoliaSearchClient = searchClient(appId, apiKey);
    algoliaIndexName = indexName;
}

export { algoliaSearchClient, algoliaIndexName };